var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"aa-about"},[_c('AboutHeading',{attrs:{"items":this.itemsHeading}}),_c('CustomersCard',{attrs:{"items":this.itemsCustomers}}),_c('OurTeamCard',{attrs:{"items":this.itemsTeam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }